import React from 'react';
import {FadeIn} from '../../components/ui/FadeIn';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiBriefcase,FiTrendingUp,FiDollarSign,FiCheck}=FiIcons;

const Agencies=()=> {
  return (
    <div className="pt-20 pb-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeIn className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-black mb-6 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">
          10x your content output for every client
        </h1>
        <p className="text-xl text-white/80 max-w-3xl mx-auto drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
          White-label the platform,eliminate the video repurposing bottleneck,and charge clients for premium deliverables.
        </p>
      </FadeIn>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
        <FadeIn delay={0.1}>
          <div className="glass-card p-8 text-center border border-brand-electric/40">
            <SafeIcon icon={FiBriefcase} className="text-5xl text-brand-electric mx-auto mb-4" />
            <div className="text-4xl font-black text-white mb-2">50+</div>
            <p className="text-white/70">Videos Processed Per Day</p>
          </div>
        </FadeIn>
        <FadeIn delay={0.2}>
          <div className="glass-card p-8 text-center border border-brand-gold/40">
            <SafeIcon icon={FiDollarSign} className="text-5xl text-brand-gold mx-auto mb-4" />
            <div className="text-4xl font-black text-white mb-2">$40k+</div>
            <p className="text-white/70">Avg Monthly Revenue Per Agency</p>
          </div>
        </FadeIn>
        <FadeIn delay={0.3}>
          <div className="glass-card p-8 text-center border border-brand-mint/40">
            <SafeIcon icon={FiTrendingUp} className="text-5xl text-brand-mint mx-auto mb-4" />
            <div className="text-4xl font-black text-white mb-2">10x ROI</div>
            <p className="text-white/70">Typical Client Billing vs Cost</p>
          </div>
        </FadeIn>
      </div>

      <div className="max-w-4xl mx-auto glass-card p-8 md:p-12 mb-16 border-2 border-brand-border/60">
        <h3 className="text-2xl font-bold mb-8 border-b-2 border-brand-electric/20 pb-4 text-white">The Agency Workflow</h3>
        <div className="space-y-6">
          {[
            {text: "Client sends raw video library or YouTube links",detail: "Bulk upload support for 50+ videos at once"},
            {text: "Queue batch transformation to run overnight",detail: "Automated processing while you sleep"},
            {text: "Client's custom brand kit applied automatically to all slides",detail: "Logo,colors,fonts — fully customized"},
            {text: "Deliver full package: Slides + Motion Video + PDF Handouts",detail: "Professional deliverables in multiple formats"},
            {text: "Bill client 10x the API cost for a high-value service",detail: "Premium pricing for premium results"}
          ].map((step,idx)=> (
            <div key={idx} className="flex gap-4 items-start">
              <div className="w-8 h-8 rounded-full bg-brand-electric/20 text-brand-electric flex items-center justify-center font-bold shrink-0 border-2 border-brand-electric/40 shadow-[0_0_10px_rgba(0,229,255,0.3)]">
                {idx + 1}
              </div>
              <div>
                <p className="text-lg text-white font-semibold mb-1">{step.text}</p>
                <p className="text-sm text-white/60">{step.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* White Label Section */}
      <FadeIn className="mb-16">
        <div className="glass-card p-8 border border-brand-neon/40 bg-brand-neon/5">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">White-Label Features</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              'Custom subdomain (yourcompany.vidrevive.com)',
              'Your branding throughout the platform',
              'Client portal access',
              'API keys for integration',
              'Dedicated account manager',
              'Priority support channel',
              'Custom pricing tiers',
              'Revenue share options'
            ].map((feature,idx)=> (
              <div key={idx} className="flex items-center gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0" />
                <span className="text-white/90">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </FadeIn>

      <FadeIn className="text-center">
        <div className="inline-block glass-card p-6 border-2 border-brand-neon/40 bg-brand-neon/5 shadow-[0_0_30px_rgba(124,58,237,0.2)] mb-6">
          <p className="text-lg font-medium text-white mb-2">Deploy your own branded instance</p>
          <code className="text-brand-electric font-mono text-lg drop-shadow-[0_0_10px_rgba(0,229,255,0.5)]">yourcompany.vidrevive.com</code>
        </div>
        <div>
          <button className="btn-cta py-4 px-12 text-lg mb-3 text-brand-neon">
            Start Free
          </button>
          <p className="text-sm text-white/60">No credit card required</p>
        </div>
      </FadeIn>
    </div>
  );
};

export default Agencies;